import { useFeatureFlagsContext } from '../app/providers/FeatureFlagsProvider';
import {
  useCompanyId,
  useProjectStore,
  useSelectedCompany,
  useTargetId,
  useTargetType,
} from '../store/projectStore';
import { TARGET_TYPE } from '../utils/target-scope.utils';
import { useTargets } from './useTargets';

export function resolveAiApplicationKindPending({
  kindMissing,
  isFeatureFlagsFetched,
  catalogEnabled,
  isFetched,
  isLoading,
  isFetching,
  hasError,
}: {
  kindMissing: boolean;
  isFeatureFlagsFetched: boolean;
  catalogEnabled: boolean;
  isFetched: boolean;
  isLoading: boolean;
  isFetching: boolean;
  hasError: boolean;
}): boolean {
  if (!kindMissing) {
    return false;
  }

  if (!isFeatureFlagsFetched) {
    return true;
  }

  if (!catalogEnabled || hasError) {
    return false;
  }

  return !isFetched || isLoading || isFetching;
}

export function useIsAiApplicationKindPending(): boolean {
  const targetId = useTargetId();
  const targetType = useTargetType();
  const companyId = useCompanyId();
  const selectedCompany = useSelectedCompany();
  const aiKind = useProjectStore((state) => state.selectedTarget?.aiKind);
  const { isFetched: isFeatureFlagsFetched } = useFeatureFlagsContext();
  const { isLoading, isFetching, isFetched, error } = useTargets({ companyId });

  return resolveAiApplicationKindPending({
    kindMissing:
      targetType === TARGET_TYPE.AI_APPLICATION &&
      Boolean(targetId) &&
      aiKind == null,
    isFeatureFlagsFetched,
    catalogEnabled: Boolean(selectedCompany?.tenantId),
    isFetched,
    isLoading,
    isFetching,
    hasError: Boolean(error),
  });
}
